<div class="container container-sm container-md container-lg container-xl notfound-content {{mode_html == true ? 'dark': ''}}" *ngIf="viewnotpage">
    <div class="row mt-5 mb-5 pt-5 justify-content-center align-self-center">
        <object type="image/svg+xml" data="../../assets/img/404/404-qualitysoft.svg" class="img-404-quality">upss!! 404</object>
    </div>
</div>
